import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SccPopupComponent } from './scc-popup.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InstancePreviewModule } from '../../instance-preview/instance-preview.module';
import { PreviewCardModule } from '../../preview-card/preview-card.module';
import { PipesModule } from '../../../pipes/pipes.module';

@NgModule({
  declarations: [SccPopupComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild(),
    InstancePreviewModule,
    PreviewCardModule,
    PipesModule
  ],
  exports: [SccPopupComponent]
})
export class SccPopupModule { }
